// import React, { useEffect, useState, useRef } from 'react';
// import { useParams, useLocation } from 'react-router-dom';
// import './HealthNavigationPage.css';
// import { routePaths } from 'services/routing';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchTotalRecord } from './ehrActions';
// import { Header, BackAction, BottomNavigation } from 'shared';
// import ProfileSwitcher from 'profiles/page/ProfileSwitcher.jsx';
// import { DataLoadingStatus } from 'shared';
// import LoadingPage from 'shared/loading/LoadingPage';

// export default function HealthNavigationPage() {
//     const [expandedTables, setExpandedTables] = useState({});
//     const hasFetchedRef = useRef(false);

//     const { dataType: rawDataType } = useParams();

//     const dataTypeMap = {
//         'Active Problems': 'ActiveProblems',
//         'Additional Health Concerns': 'HealthConcerns',
//         'Administered Medication': 'MedicationsAdministered',
//         'Advanced Directives': 'AdvancedDirectives',
//         'Anesthesia Record': 'AnesthesiaRecord',
//         'Care Plan': 'planOfCare',
//         'Discharge Disposition': 'DischargeDisposition',
//         'Discharge Instructions': 'DischargeInstructions',
//         'Discontinued Medications': 'DiscontinuedMedications',
//         'ED Notes': 'EDNotes',
//         'Eye Exam': 'Eye Exam',
//         'Historical Medications': 'HistoricalMedications',
//         'History & Physical (H&P)': 'HealthAndPhysical',
//         'Medical History': 'MedicalHistory',
//         'Medications at Time of Discharge': 'MedicationAtTimeOfDischarge',
//         'Miscellaneous Notes': 'MiscellaneousNotes',
//         'Ordered Prescriptions': 'OrderedPrescriptions',
//         'OR Notes': 'ORNotes',
//         'Patient Instructions': 'PatientInstruction',
//         'Progress Notes': 'ProgressNotes',
//         'Reason for Visit': 'ReasonForVisit',
//         'Resolved Problems': 'ResolvedProblems',
//         'Social History': 'SocialHistory',
//         'Surgical History': 'SurgicalHistory',
//         'Surgery Details': 'SurgeryDetails',
//         'Vital Signs': 'VitalSigns',
//         'Visit Diagnoses': 'VisitDiagnoses',
//         'Lab Reports': 'LabReport',
//         'Family History': 'FamilyHistory',
//         'Discharge Summaries': 'DischargeSummaries',
//         'CCD': 'CCD'
//     };

//     const dataType = dataTypeMap[rawDataType] || rawDataType;

//     const dispatch = useDispatch();
//     const { data, loading, error } = useSelector(state => state.ehr);

//     const location = useLocation();
//     const { email, ssn } = location.state || {};

//     const extractDatesFromTable = (htmlString) => {
//         if (!htmlString) return [];

//         const dateRegex = /\b(?:\d{1,2}[-\/\.]\d{1,2}[-\/\.]\d{2,4}|[A-Za-z]{3}[-\/\.]\d{1,2}[-\/\.]\d{4})\b/g;
//         const matches = htmlString.match(dateRegex) || [];

//         const monthMap = {
//             Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
//             Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
//         };

//         const normalizeDate = (dateStr) => {
//             const cleaned = dateStr.replace(/[\/\.]/g, '-');

//             const numericMatch = cleaned.match(/^(\d{1,2})-(\d{1,2})-(\d{2,4})$/);
//             if (numericMatch) {
//                 const [, part1, part2, year] = numericMatch;
//                 const month = parseInt(part1, 10) <= 12 ? part1 : part2;
//                 const day = parseInt(part1, 10) <= 12 ? part2 : part1;
//                 const fullYear = year.length === 2 ? '20' + year : year;
//                 return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${fullYear}`;
//             }

//             const textMatch = cleaned.match(/^([A-Za-z]{3})-(\d{1,2})-(\d{4})$/);
//             if (textMatch) {
//                 const [, monthStr, day, year] = textMatch;
//                 const normalizedMonth = monthMap[monthStr.charAt(0).toUpperCase() + monthStr.slice(1).toLowerCase()];
//                 if (normalizedMonth) {
//                     return `${normalizedMonth}/${day.padStart(2, '0')}/${year}`;
//                 }
//             }

//             return null;
//         };

//         const allValidDates = matches
//             .map(normalizeDate)
//             .filter(Boolean)
//             .map(dateStr => new Date(dateStr))
//             .filter(d => !isNaN(d));

//         if (allValidDates.length === 0) return [];

//         const today = new Date();
//         const pastDates = allValidDates.filter(date => date <= today);

//         const selectedDate = (pastDates.length > 0 ? pastDates : allValidDates)
//             .sort((a, b) => b - a)[0];

//         if (!selectedDate) return [];

//         return [selectedDate.toLocaleDateString('en-US')];
//     };

//     useEffect(() => {
//         const canFetch = email && ssn;

//         if (
//             dataType &&
//             !data[dataType] &&
//             !loading &&
//             !hasFetchedRef.current &&
//             canFetch
//         ) {
//             hasFetchedRef.current = true;
//             dispatch(fetchTotalRecord(email, ssn));
//         }
//     }, [dispatch, data, dataType, loading, email, ssn]);

//     useEffect(() => {
//         if (data[dataType]) {
//             const records = data[dataType];
//             const initialExpandedState = {};

//             if (Array.isArray(records)) {
//                 records.forEach((_, index) => {
//                     initialExpandedState[index] = index === 0;
//                 });
//             } else {
//                 Object.keys(records).forEach((key, index) => {
//                     initialExpandedState[index] = index === 0;
//                 });
//             }
//             setExpandedTables(initialExpandedState);
//         }
//     }, [data, dataType]);

//     const handleTableToggle = (tableIndex) => {
//         setExpandedTables(prevState => ({
//             ...prevState,
//             [tableIndex]: !prevState[tableIndex]
//         }));
//     };

//     const renderTable = () => {
//         let records = data[dataType];

//         if (!Array.isArray(records)) {
//             records = records ? Object.values(records) : [];
//         }

//         records = records
//             .map(entry => {
//                 const extractedDates = extractDatesFromTable(entry?.table);
//                 return { ...entry, extractedDates };
//             })
//             .filter(entry => entry.extractedDates.length > 0 && !entry.extractedDates.includes("Not on file"));

//         if (records.length === 0) {
//             return <div className='record-error'>No data available for "{dataType}" </div>;
//         }

//         records.sort((a, b) => {
//             const dateA = new Date(a.extractedDates[0]);
//             const dateB = new Date(b.extractedDates[0]);
//             return dateB - dateA;
//         });

//         const groupByOrganization = (records) => {
//             return records.reduce((groups, item) => {
//                 const org = item.organizationName || "Unknown Organization";
//                 if (!groups[org]) {
//                     groups[org] = [];
//                 }
//                 groups[org].push(item);
//                 return groups;
//             }, {});
//         };


//         return records.map((entry, index) => (
//             <div key={index} style={{ marginBottom: '20px', border: "1px solid gainsboro", padding: "10px 5px", borderRadius: "5px" }} className='ehr_container'>
//                 <div className='ehr-heading' onClick={() => handleTableToggle(index)} >
//                     <div className='org-name'>{entry?.organizationName}</div>
//                     {entry.extractedDates.length > 0 && (
//                         <div style={{ marginTop: '10px', fontSize: '14px', color: '#555' }}>
//                             {entry.extractedDates}
//                         </div>
//                     )}
//                     <div className='view-close-button' style={{ color: `${expandedTables[index] ? 'red' : 'blue'}` }}>
//                         {expandedTables[index] ? 'Close' : 'View'}
//                     </div>
//                 </div>
//                 {expandedTables[index] && (
//                     <div
//                         style={{ width: "100%", display: "flex", justifyContent: "space-between", textAlign: "start", marginTop: "5px", padding: "10px" }}
//                         className='ehr-table'
//                         dangerouslySetInnerHTML={{ __html: entry?.table }}
//                     />
//                 )}
//             </div>
//         ));
//     };

//     if (!email || !ssn) {
//         return (
//             <div className='error-page'>
//                 <Header
//                     farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
//                     centerElement={<p className='center-ele'>Electronic Health Record</p>}
//                 />
//                 <div className='record-error'>
//                     <p>Missing required information to fetch records.</p>
//                 </div>
//             </div>
//         );
//     }

//     if (loading) {
//         return <LoadingPage />;
//     }

//     if (error) {
//         return (
//             <div className='error-page'>
//                 <Header
//                     farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
//                     centerElement={<p className='center-ele'>Electronic Health Record</p>}
//                 />
//                 <div className='record-error'>
//                     <p>No Information Available</p>
//                 </div>
//             </div>
//         );
//     }

//     if (!data[dataType]) {
//         return (
//             <div className='error-page'>
//                 <Header
//                     farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
//                     centerElement={<p className='center-ele'>Electronic Health Record</p>}
//                 />
//                 <div className='record-error'>
//                     <p>No Information Available</p>
//                 </div>
//             </div>
//         );
//     }

//     const leftElement = <ProfileSwitcher readonly={false} />;
//     const backAction = <BackAction to={routePaths.electronicHealthRecord} />;
//     const centerElement = <p style={{ fontSize: '16px' }}>{dataType.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</p>;

//     return (
//         <div className="Detail_container">
//             <Header
//                 farLeftElement={backAction}
//                 leftElement={leftElement}
//                 centerElement={centerElement}
//             />
//             <main id="mainContentContainer" style={{ padding: '20px' }}>
//                 <DataLoadingStatus loading={loading} error={error} overlay>
//                     {renderTable()}
//                 </DataLoadingStatus>
//             </main>
//             <BottomNavigation />
//         </div>
//     );
// }


import React, { useEffect, useState, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './HealthNavigationPage.css';
import { routePaths } from 'services/routing';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIasDocuments } from './IasEhr';
import { Header, BackAction, BottomNavigation } from 'shared';
import ProfileSwitcher from 'profiles/page/ProfileSwitcher.jsx';
import { DataLoadingStatus } from 'shared';
import LoadingPage from 'shared/loading/LoadingPage';
import IasEhrData from './IasEhrData';

export default function HealthNavigationPageIas() {
    const [expandedTables, setExpandedTables] = useState({});
    const hasFetchedRef = useRef(false);

    const { dataType: rawDataType } = useParams();

    const dataTypeMap = {
        'Active Problems': 'ActiveProblems',
        'Additional Health Concerns': 'HealthConcerns',
        'Administered Medication': 'MedicationsAdministered',
        'Advanced Directives': 'AdvancedDirectives',
        'Anesthesia Record': 'AnesthesiaRecord',
        'Care Plan': 'planOfCare',
        'Discharge Disposition': 'DischargeDisposition',
        'Discharge Instructions': 'DischargeInstructions',
        'Discontinued Medications': 'DiscontinuedMedications',
        'ED Notes': 'EDNotes',
        'Eye Exam': 'Eye Exam',
        'Historical Medications': 'HistoricalMedications',
        'History & Physical (H&P)': 'HealthAndPhysical',
        'Medical History': 'MedicalHistory',
        'Medications at Time of Discharge': 'MedicationAtTimeOfDischarge',
        'Miscellaneous Notes': 'MiscellaneousNotes',
        'Ordered Prescriptions': 'OrderedPrescriptions',
        'OR Notes': 'ORNotes',
        'Patient Instructions': 'PatientInstruction',
        'Progress Notes': 'ProgressNotes',
        'Reason for Visit': 'ReasonForVisit',
        'Resolved Problems': 'ResolvedProblems',
        'Social History': 'SocialHistory',
        'Surgical History': 'SurgicalHistory',
        'Surgery Details': 'SurgeryDetails',
        'Vital Signs': 'VitalSigns',
        'Visit Diagnoses': 'VisitDiagnoses',
        'Lab Reports': 'LabReport',
        'Family History': 'FamilyHistory',
        'Discharge Summaries': 'DischargeSummaries',
        'CCD': 'CCD'
    };

    const dataType = dataTypeMap[rawDataType] || rawDataType;

    const dispatch = useDispatch();
    const { documents, loading, error } = useSelector(state => state.iasEhr);

    const location = useLocation();
    const { ssn } = location.state || {};

    console.log(ssn);
    console.log("ias document page ");

    if (dataType === 'Images and Documents') {
        return (
            <div className="Detail_container">
                <Header
                    farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
                    centerElement={<p style={{ fontSize: '16px' }}>{dataType}</p>}
                    leftElement={<ProfileSwitcher readonly={false} />}

                />
                <main id="mainContentContainer" style={{ padding: '20px' }}>
                    {loading ? (
                        <LoadingPage />
                    ) : (
                        <IasEhrData
                            ssn={ssn}
                            status={status}
                        />
                    )}
                </main>
                <BottomNavigation />
            </div>
        );
    }



    const extractDatesFromTable = (htmlString) => {
        if (!htmlString) return [];

        const dateRegex = /\b(?:\d{1,2}[-\/\.]\d{1,2}[-\/\.]\d{2,4}|[A-Za-z]{3}[-\/\.]\d{1,2}[-\/\.]\d{4})\b/g;
        const matches = htmlString.match(dateRegex) || [];

        const monthMap = {
            Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
            Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
        };

        const normalizeDate = (dateStr) => {
            const cleaned = dateStr.replace(/[\/\.]/g, '-');
            const numericMatch = cleaned.match(/^(\d{1,2})-(\d{1,2})-(\d{2,4})$/);
            if (numericMatch) {
                const [, part1, part2, year] = numericMatch;
                const month = parseInt(part1, 10) <= 12 ? part1 : part2;
                const day = parseInt(part1, 10) <= 12 ? part2 : part1;
                const fullYear = year.length === 2 ? '20' + year : year;
                return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${fullYear}`;
            }

            const textMatch = cleaned.match(/^([A-Za-z]{3})-(\d{1,2})-(\d{4})$/);
            if (textMatch) {
                const [, monthStr, day, year] = textMatch;
                const normalizedMonth = monthMap[monthStr.charAt(0).toUpperCase() + monthStr.slice(1).toLowerCase()];
                if (normalizedMonth) {
                    return `${normalizedMonth}/${day.padStart(2, '0')}/${year}`;
                }
            }

            return null;
        };

        const allValidDates = matches
            .map(normalizeDate)
            .filter(Boolean)
            .map(dateStr => new Date(dateStr))
            .filter(d => !isNaN(d));

        if (allValidDates.length === 0) return [];

        const today = new Date();
        const pastDates = allValidDates.filter(date => date <= today);

        const selectedDate = (pastDates.length > 0 ? pastDates : allValidDates)
            .sort((a, b) => b - a)[0];

        if (!selectedDate) return [];

        return [selectedDate.toLocaleDateString('en-US')];
    };

    useEffect(() => {
        const canFetch = ssn;
        if (dataType === 'Images and Documents') return;
        const payload = {
            value: ssn
        };
        if (
            dataType &&
            !documents[dataType] &&
            !loading &&
            !hasFetchedRef.current &&
            canFetch
        ) {
            hasFetchedRef.current = true;
            dispatch(fetchIasDocuments(payload));
        }
    }, [dispatch, documents, dataType, loading, ssn]);

    useEffect(() => {
        if (dataType === 'Images and Documents') return;
        if (documents[dataType]) {
            const records = documents[dataType];
            const initialExpandedState = {};

            if (Array.isArray(records)) {
                records.forEach((_, index) => {
                    initialExpandedState[index] = index === 0;
                });
            } else {
                Object.keys(records).forEach((key, index) => {
                    initialExpandedState[index] = index === 0;
                });
            }
            setExpandedTables(initialExpandedState);
        }
    }, [documents, dataType]);

    const handleTableToggle = (tableIndex) => {
        setExpandedTables(prevState => ({
            ...prevState,
            [tableIndex]: !prevState[tableIndex]
        }));
    };

    const renderTable = () => {

        if (dataType === "Images and Documents") {
            return <IasEhrData ssn={ssn} status={status} records={documents[dataType]} />;
        }

        let records = documents[dataType];

        if (!Array.isArray(records)) {
            records = records ? Object.values(records) : [];
        }

        records = records
            .filter(entry => {
                const html = entry?.table?.toLowerCase() || '';
                return !["not on file", "no information"].some(keyword => html.includes(keyword));
            })
            .map(entry => {
                const extractedDates = extractDatesFromTable(entry?.table);
                return { ...entry, extractedDates };
            });
        // .filter(entry => entry.extractedDates.length > 0 && !entry.extractedDates.includes("Not on file"));

        if (records.length === 0) {
            return <div className='record-error'>No data available for "{dataType}" </div>;
        }

        if (dataType === 'CCD') {
            const groupedByOrg = records.reduce((acc, curr) => {
                const orgName = curr.organizationName || 'Unknown';
                if (!acc[orgName]) acc[orgName] = [];
                acc[orgName].push(curr);
                return acc;
            }, {});

            return Object.entries(groupedByOrg).map(([orgName, sections]) => (
                <div
                    key={orgName.id}
                    style={{
                        border: "1px solid gainsboro",
                        borderRadius: "5px",
                        marginBottom: "20px",
                        padding: "10px",
                        background: "#f9f9f9"
                    }}
                >
                    <h3 style={{ marginBottom: "10px", color: "#049fda" }}>
                        {orgName} CCD
                    </h3>
                    {sections.map((section) => (
                        <div
                            key={section.id}
                            style={{
                                marginBottom: "12px",
                                padding: "8px 12px",
                                background: "#fff",
                                borderRadius: "4px",
                                border: "1px solid #eee"
                            }}
                        >
                            <h4 style={{ margin: "5px 0", color: "#666" }}>
                                {section.title}
                            </h4>
                            <div
                                style={{ width: "100%", display: "flex", justifyContent: "space-between", textAlign: "start", marginTop: "5px", padding: "10px" }}
                                className='ehr-table'
                                dangerouslySetInnerHTML={{ __html: section.table }}
                            />
                        </div>
                    ))}
                </div>
            ));
        }

        records.sort((a, b) => {
            const dateA = new Date(a.extractedDates[0]);
            const dateB = new Date(b.extractedDates[0]);
            return dateB - dateA;
        });

        return records.map((entry, index) => (
            <div key={index} style={{ marginBottom: '20px', border: "1px solid gainsboro", padding: "10px 5px", borderRadius: "5px" }} className='ehr_container'>
                <div className='ehr-heading' onClick={() => handleTableToggle(index)} >
                    <div className='org-name'>{entry?.organizationName}</div>
                    {entry.extractedDates.length > 0 && (
                        <div style={{ marginTop: '10px', fontSize: '14px', color: '#555' }}>
                            {entry.extractedDates}
                        </div>
                    )}
                    <div className='view-close-button' style={{ color: `${expandedTables[index] ? 'red' : 'blue'}` }}>
                        {expandedTables[index] ? 'Close' : 'View'}
                    </div>
                </div>
                {expandedTables[index] && (
                    <div
                        style={{ width: "100%", display: "flex", justifyContent: "space-between", textAlign: "start", marginTop: "5px", padding: "10px" }}
                        className='ehr-table'
                        dangerouslySetInnerHTML={{ __html: entry?.table }}
                    />
                )}
            </div>
        ));
    };

    if (!ssn) {
        return (
            <div className='error-page'>
                <Header
                    farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
                    centerElement={<p className='center-ele'>Electronic Health Record</p>}
                    leftElement={<ProfileSwitcher readonly={false} />}

                />
                <div className='record-error'>
                    <p>Missing required information to fetch records.</p>
                </div>
            </div>
        );
    }

    if (loading) {
        return <LoadingPage />;
    }

    if (error) {
        return (
            <div className='error-page'>
                <Header
                    farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
                    centerElement={<p className='center-ele'>Electronic Health Record</p>}
                    leftElement={<ProfileSwitcher readonly={false} />}

                />
                <div className='record-error'>
                    <p>No Information Available</p>
                </div>
            </div>
        );
    }

    if (!documents[dataType]) {
        return (
            <div className='error-page'>
                <Header
                    farLeftElement={<BackAction to={routePaths.electronicHealthRecord} />}
                    centerElement={<p className='center-ele'>Electronic Health Record</p>}
                    leftElement={<ProfileSwitcher readonly={false} />}
                />
                <div className='record-error'>
                    <p>No Information Available</p>
                </div>
            </div>
        );
    }

    const leftElement = <ProfileSwitcher readonly={false} />;
    const backAction = <BackAction to={routePaths.electronicHealthRecord} />;
    const centerElement = <p style={{ fontSize: '16px' }}>{dataType.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</p>;

    return (
        <div className="Detail_container">
            <Header
                farLeftElement={backAction}
                leftElement={leftElement}
                centerElement={centerElement}
            />
            <main id="mainContentContainer" style={{ padding: '20px' }}>
                <DataLoadingStatus loading={loading} error={error} overlay>
                    {renderTable()}
                </DataLoadingStatus>
            </main>
            <BottomNavigation />
        </div>
    );
}
